import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';

export class GATrackingFooterNavigationEvent implements GATrackingEvent {

  constructor(
    private path: string,
    private title: string
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.FooterNavigationClick;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      label: this.title,
      gtmCustom: {
        link: {
          path: this.path,
          title: this.title
        }
      }
    };
  }
}
